module.exports = __webpack_public_path__ + "static/img/210.f32fcf45.png";